module.exports = __webpack_public_path__ + "img/shachen.54025709.png";